import { render, staticRenderFns } from "./BaseImage.vue?vue&type=template&id=0ea33a2c&scoped=true&"
import script from "./BaseImage.vue?vue&type=script&lang=ts&"
export * from "./BaseImage.vue?vue&type=script&lang=ts&"
import style0 from "./BaseImage.vue?vue&type=style&index=0&id=0ea33a2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea33a2c",
  null
  
)

export default component.exports